import React from "react";
import { useFormik } from "formik";
import * as Yup from 'yup';
import axios from 'axios';
import "./HeroForm.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const HeroForm = () => {
  const navigate = useNavigate()
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Full Name is required')
      .matches(/^[A-Za-z\s]{2,50}$/, 'Name must contain only letters and spaces (2-50 chars)'),

    email: Yup.string()
      .required('Email is required')
      .email('Enter a valid email address'),
    phone: Yup.string()
      .required('Contact Number is required')
      .matches(/^\+\d{1,4}-\d{6,14}$/, 'Enter a valid international phone number (e.g., +91-9876543210)'),
    companyname: Yup.string()
      .required('Company Name is required')
      .min(2, 'Company name must be at least 2 characters')
      .max(100, 'Company name must be under 100 characters'),
    select: Yup.string()
      .required('Company Size is required'),
    profession: Yup.string()
      .required('Designation is required')
      .matches(/^[A-Za-z\s]{2,50}$/, 'Designation must contain only letters and spaces'),
    message: Yup.string()
      .required('Inquiry message is required')
      .min(10, 'Inquiry must be at least 10 characters')
      .max(500, 'Inquiry must be under 500 characters'),

    consent: Yup.boolean()
      .oneOf([true], 'You must accept the terms and conditions'),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "+91-" || "",
      countryCode: "in",
      select: "",
      companyname: "",
      profession: "",
      message: "",
      consent: false,
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await axios.post('https://api.bastionex.net/api/v1/user/saveContactInfo', values)
        toast.success(response?.data?.message);
        navigate('/thankyou')
      } catch (error) {
        toast.error(error?.data?.message);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} id="form">
      <h2 className="form-title">Your Vision, Our Tech – Let’s Connect</h2>

      <div className="form-group-wrapper">
        <div className="form-group">
          <div className="formgroup-innerDiv">
            <input
              type="text"
              name="name"
              placeholder="Full Name*"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="error">{formik.errors.name}</div>
            )}
          </div>
          <div className="formgroup-innerDiv">
            <input
              type="email"
              name="email"
              placeholder="Email*"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="error">{formik.errors.email}</div>
            )}
          </div>
        </div>

        <div className="form-group">
          <div className="formgroup-innerDiv">
            <PhoneInput

              name="phone"
              value={formik?.values?.phone}
              country={formik?.values?.countryCode}
              countryCodeEditable={false}
              onBlur={formik.handleBlur}
              onChange={(value, country) => {
                console.log("value, country", value, country);
                formik.setFieldValue(
                  "phone",
                  `+${country.dialCode}-${value.substring(
                    country.dialCode.length
                  )}`
                );
                formik.setFieldValue("countryCode", country.dialCode);
              }}
              className="reactInputNumber"
              style={{margin:"0", width:"100%"}}
            />
            {formik.touched.phone && formik.errors.phone && (
              <div className="error">{formik.errors.phone}</div>
            )}
          </div>
          <div className="formgroup-innerDiv">
            <input
              type="text"
              name="companyname"
              placeholder="Company Name*"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.companyname}
            />
            {formik.touched.companyname && formik.errors.companyname && (
              <div className="error">{formik.errors.companyname}</div>
            )}
          </div>
        </div>

        <div className="form-group">
          <div className="formgroup-innerDiv">
            <select
              name="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.select}
              style={{ width: "100%"}}
              required
            >
              <option value="" hidden>
                Company Size*
              </option>
              <option value="10">0-10 Employees</option>
              <option value="25">11-25 Employees</option>
              <option value="50">26-50 Employees</option>
              <option value="100">51-100 Employees</option>
              <option value="150">100+ Employees</option>
            </select>
            {formik.touched.select && formik.errors.select && (
              <div className="error">{formik.errors.select}</div>
            )}
          </div>
          <div className="formgroup-innerDiv">
            <input
              type="text"
              name="profession"
              placeholder="Designation*"
              onChange={formik.handleChange}
              value={formik.values.profession}
              onBlur={formik.handleBlur}
            />
            {formik.touched.profession && formik.errors.profession && (
              <div className="error">{formik.errors.profession}</div>
            )}
          </div>
        </div>

        <div className="form-group" >
          <div style={{ width: "100%" }}  className="formgroup-innerDiv">
            <textarea
              name="message"
              placeholder="Message"
              onChange={formik.handleChange}
              value={formik.values.message}
              onBlur={formik.handleBlur}
            />
            {formik.touched.message && formik.errors.message && (
              <div className="error">{formik.errors.message}</div>
            )}
          </div>
        </div>

        <div className="form-group checkboxgroup" style={{marginBottom: formik.touched.consent && formik.errors.consent ? "0" : ""}}>
          {/* <input
            type="checkbox"
            name="consent"
            onChange={formik.handleChange}
            checked={formik.values.consent}
            style={{ width: "18px", margin: "0" }}
          />
          <label>
            I consent BastionEx to use my data for contacting through
            Call/ SMS/ Email
          </label> */}
          <label class="custom-checkbox">
    <input type="checkbox" 
            name="consent"
            onChange={formik.handleChange}
            checked={formik.values.consent}/>
    <span class="checkmark"></span>
    I consent BastionEx to use my data for contacting through Call/ SMS/ Email
  </label>
        </div>
        {formik.touched.consent && formik.errors.consent && (
          <div className="consentError">{formik.errors.consent}</div>
        )}
        <button type="submit" className="form-button">
          {formik.isSubmitting ? <ClipLoader size={25} /> : "Submit"}
        </button>
      </div>
      <ToastContainer position="top-right" autoClose={3000} color="#fff" />
    </form>
  );
};

export default HeroForm;
